import { UPDATE_COUNTRY_LIST } from "../actions"

const countryList = (state = "", { type, payload }) => {
  switch (type) {
    case UPDATE_COUNTRY_LIST:
      return payload.countryList;
    default:
      return state;
  }
};

export default countryList;



// WEBPACK FOOTER //
// ./src/reducers/countryList.js